import React from 'react';
import HomeView from './components/HomeView/';

export default (store) => ({
  component : (props) => <HomeView {...props} />,
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Landing/index.js